<template>
  <template v-if="showLink">
    <router-link
      :to="{
        name: 'search-result',
        query: {
          q: props?.text?.name,
          type: 'activities',
        },
      }"
      v-if="!loading"
    >
      <div
        class="flex px-8 items-center justify-center h-24 w-fit-content"
        :class="[version === 'primary' ? '' : 'bd-1 bd-hairline']"
      >

        <img
          :src="`${ASSETS_CDN}/icons/new_activities/${props?.text?.code}.svg`"
          alt=""
          class="w-24 h-24 mr-8 activity-icon"
        />
        <p
          class="mb-0 fs-14 lh-18 ink "
          :class="[version === 'primary' ? '' : 'brand-green']"
        >{{ props?.text?.name }}</p>
      </div>
    </router-link>
    <SkeletonLoading
      v-else
      :height="'26px'"
      :width="randomWidth"
      :border-radius="'1000px'"
    />
  </template>
  <template v-else>
    <div class="flex px-8 items-center justify-center h-24 w-fit-content"
         :class="[version === 'primary' ? '' : 'bd-1 bd-hairline br-999 bg-cream-deep']"
    >
      <img
        :src="`${ASSETS_CDN}/icons/new_activities/${props?.text?.code}.svg`"
        alt=""
        class="w-18 h-18 mr-8 activity-icon"
      />
      <p
        class="mb-0 fs-14 lh-18 "
        :class="[version === 'primary' ? 'ink' : 'brand-green white-space']"
      >{{ props?.text?.name }}</p>
    </div>
  </template>
</template>

<script setup>
import SkeletonLoading from '~/components/globals/Loading/SkeletonLoading.vue'
import { computed } from 'vue'
import {assetCDN, getRandomArbitrary} from '~/helper'

const props = defineProps({
  text: {
    type: Object,
    default: () => {},
  },
  loading: {
    type: Boolean,
    default: false,
  },
  showLink: {
    type: Boolean,
    default: true,
  },
  version: {
    type: String,
    required: false,
    default: 'primary',
  },
})

// const map = {
//   Adventure: 'adventure',
//   'Beach & Sea': 'beach',
//   Cruising: 'cruising',
//   Cycling: 'cycling',
//   'Culture & Arts': 'culturearts',
//   Diving: 'diving',
//   'Outdoors & Nature': 'outdoors',
//   'Food & Drink': 'food',
//   Motorcycling: 'motorcycling',
//   Relaxation: 'relaxation',
//   Skiing: 'skiing',
//   'Hiking & Trekking': 'hiking',
//   Sightseeing: 'sightseeing',
//   Golfing: 'golfing',
//   More: 'more',
//   Wellness: 'wellness',
//   'Community Giving': 'community-giving'
// }

const randomWidth = computed(() => `${getRandomArbitrary(50, 175)}px`)

const ASSETS_CDN = assetCDN()
</script>

<style lang="scss" scoped>
// new_activities/*.svg activity icons are <img>-loaded via a data-driven `${code}.svg` path and are
// visually monochrome (one #338CFF glyph; the #D9D9D9 rect is an alpha mask, not a colour). Recolour
// the whole set to the primary brand green with one CSS filter — no per-file edits, no CDN re-sync.
.activity-icon {
  // solved black → $brand-green #197660 (source normalised to black first, so blue tints cleanly;
  // achieved rgb(25,118,96), loss 0.037)
  filter: brightness(0) saturate(100%) invert(81%) sepia(44%) saturate(3721%) hue-rotate(111deg) brightness(47%) contrast(80%);
}
</style>
